import React, { Suspense, useLayoutEffect } from 'react';
import { View } from "@/views/app/style";
import Nav from '@/views/component/nav';

import DayFreeAward from '@/views/component/dayFree';
import DayRecharge from '@/views/component/dayRecharge';
import MonthRecharge from '@/views/component/monthRecharge';
import Discount from '@/views/component/discount';
import Rules from '@/views/component/rules';
import { useMobx } from "@/utils/hooks";
import { getUrlParams, verifyLogin, login, loginStat, getDayEndTime } from "@/utils/util";
import IPublic from "@/interface/public";
import { useRequest } from "ahooks";
import { $ajax } from "@/utils/request";

function Index() {
  const store = useMobx('store');
  useRequest(() => $ajax<{ pval: string } | null>(`//gxhd.game.yy.com/shopmall/get.do`, {
    data: {
      actCode: CONFIG.code.YYVIP2022_free_01,
      type: 'wxAwards'
    },
    dataType: 'jsonp'
  }), {
    onSuccess: (data, params) => {
      const bool = data === null ? true : false;
      store.setNoParticipate(bool);
    }
  });

  const { runAsync: updateParticipate } = useRequest(() => $ajax(`//gxhd.game.yy.com/shopmall/addOrUpdate.do`, {
    data: {
      actCode: CONFIG.code.YYVIP2022_free_01,
      type: 'wxAwards',
      awards: 'true',
    },
    dataType: 'jsonp'
  }), {
    onSuccess: (data, params) => {
      store.setNoParticipate(false);
    }
  });

  useLayoutEffect(() => {
    init();

    resetPage();
  }, []);

  const init = async () => {
    // url参数
    const urlParams = getUrlParams();
    store.setUrlParams(urlParams);

    // 埋点
    loginStat();

    //
    store.setUpdateParticipate(() => updateParticipate());

    // 登陆相关
    const isLogin = await verifyLogin();
    store.setLogin(isLogin);
    if (isLogin) {
      f2eGame.port.udb.getUserInfo().then((data: IPublic.UserInfo) => {
        store.setUserInfo(data)
      });
    } else {
      login()
    }
  }

  const resetPage = () => {
    const timeout = getDayEndTime().getTime() - new Date().getTime();
    // 每日0点重置
    setTimeout(() => {
      window.location.reload();
    }, timeout + 5000)
  }

  return (
    <View>
      <Nav/>
      <Suspense fallback={'加载中...'}>
        <div className="content">
          <DayFreeAward/>
          <DayRecharge/>
          <MonthRecharge/>
          <Discount/>
          <Rules/>
        </div>
      </Suspense>
    </View>
  );
}

export default Index;
